/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum ValidationFaultPaymentUnavailableEnum {
  "PPT_PSP_SCONOSCIUTO" = "PPT_PSP_SCONOSCIUTO",

  "PPT_PSP_DISABILITATO" = "PPT_PSP_DISABILITATO",

  "PPT_INTERMEDIARIO_PSP_SCONOSCIUTO" = "PPT_INTERMEDIARIO_PSP_SCONOSCIUTO",

  "PPT_INTERMEDIARIO_PSP_DISABILITATO" = "PPT_INTERMEDIARIO_PSP_DISABILITATO",

  "PPT_CANALE_SCONOSCIUTO" = "PPT_CANALE_SCONOSCIUTO",

  "PPT_CANALE_DISABILITATO" = "PPT_CANALE_DISABILITATO",

  "PPT_AUTENTICAZIONE" = "PPT_AUTENTICAZIONE",

  "PPT_AUTORIZZAZIONE" = "PPT_AUTORIZZAZIONE",

  "PPT_DOMINIO_DISABILITATO" = "PPT_DOMINIO_DISABILITATO",

  "PPT_INTERMEDIARIO_PA_DISABILITATO" = "PPT_INTERMEDIARIO_PA_DISABILITATO",

  "PPT_STAZIONE_INT_PA_DISABILITATA" = "PPT_STAZIONE_INT_PA_DISABILITATA",

  "PPT_CODIFICA_PSP_SCONOSCIUTA" = "PPT_CODIFICA_PSP_SCONOSCIUTA",

  "PPT_SEMANTICA" = "PPT_SEMANTICA",

  "PPT_SYSTEM_ERROR" = "PPT_SYSTEM_ERROR",

  "PAA_SEMANTICA" = "PAA_SEMANTICA"
}

/**
 * Fault codes for errors related to well-formed requests to ECs not present inside Nodo, should be mapped to 404 HTTP status code.
 * Most of the time these are generated when users input a wrong fiscal code or notice number.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 * Possible fault codes are:
 * - `PPT_PSP_SCONOSCIUTO`
 * - `PPT_PSP_DISABILITATO`
 * - `PPT_INTERMEDIARIO_PSP_SCONOSCIUTO`
 * - `PPT_INTERMEDIARIO_PSP_DISABILITATO`
 * - `PPT_CANALE_SCONOSCIUTO`
 * - `PPT_CANALE_DISABILITATO`
 * - `PPT_AUTENTICAZIONE`
 * - `PPT_AUTORIZZAZIONE`
 * - `PPT_DOMINIO_DISABILITATO`
 * - `PPT_INTERMEDIARIO_PA_DISABILITATO`
 * - `PPT_STAZIONE_INT_PA_DISABILITATA`
 * - `PPT_CODIFICA_PSP_SCONOSCIUTA`
 * - `PPT_SEMANTICA`
 * - `PPT_SYSTEM_ERROR`
 * - `PAA_SEMANTICA`
 */

export type ValidationFaultPaymentUnavailable = t.TypeOf<
  typeof ValidationFaultPaymentUnavailable
>;
export const ValidationFaultPaymentUnavailable = enumType<
  ValidationFaultPaymentUnavailableEnum
>(ValidationFaultPaymentUnavailableEnum, "ValidationFaultPaymentUnavailable");
